import React, { useState } from 'react';
import {
    Box, Typography, Card, CardContent, Grid, Table, TableBody,
    TableCell, TableContainer, TableHead, TableRow, Button, Chip,
    TextField, MenuItem, Tabs, Tab, InputAdornment, Dialog,
    DialogTitle, DialogContent, DialogActions, LinearProgress
} from '@mui/material';
import {
    Search as SearchIcon, Add as AddIcon, Download as DownloadIcon,
    CurrencyRupee as RupeeIcon, CheckCircle as CheckIcon,
    HourglassEmpty as PendingIcon, Cancel as CancelIcon
} from '@mui/icons-material';
import { toast } from 'react-toastify';

const ProspectFees = () => {
    const [tab, setTab] = useState(0);
    const [searchTerm, setSearchTerm] = useState('');
    const [openDialog, setOpenDialog] = useState(false);
    const [formData, setFormData] = useState({ studentName: '', parentName: '', phone: '', class: '', totalFee: '', discount: '', quotedFee: '' });

    const prospects = [
        { id: 1, studentName: 'Arjun Mehta', parentName: 'Suresh Mehta', phone: '9876543210', class: 'Class 5A', totalFee: 45000, discount: 5000, quotedFee: 40000, paidDeposit: 10000, status: 'Confirmed', date: '2026-02-10', followUp: '2026-02-20' },
        { id: 2, studentName: 'Kavya Joshi', parentName: 'Ramesh Joshi', phone: '9876543211', class: 'Class 1A', totalFee: 35000, discount: 0, quotedFee: 35000, paidDeposit: 0, status: 'Quoted', date: '2026-02-12', followUp: '2026-02-18' },
        { id: 3, studentName: 'Siddharth Patil', parentName: 'Anil Patil', phone: '9876543212', class: 'Class 8A', totalFee: 50000, discount: 10000, quotedFee: 40000, paidDeposit: 40000, status: 'Paid', date: '2026-02-08', followUp: '-' },
        { id: 4, studentName: 'Riya Shah', parentName: 'Nitin Shah', phone: '9876543213', class: 'Class 3B', totalFee: 38000, discount: 3000, quotedFee: 35000, paidDeposit: 0, status: 'Pending', date: '2026-02-14', followUp: '2026-02-22' },
        { id: 5, studentName: 'Vivaan Kulkarni', parentName: 'Manoj Kulkarni', phone: '9876543214', class: 'Class LKG', totalFee: 30000, discount: 5000, quotedFee: 25000, paidDeposit: 5000, status: 'Confirmed', date: '2026-02-05', followUp: '2026-02-15' },
        { id: 6, studentName: 'Aarya Desai', parentName: 'Vikram Desai', phone: '9876543215', class: 'Class 6A', totalFee: 42000, discount: 0, quotedFee: 42000, paidDeposit: 0, status: 'Cancelled', date: '2026-02-01', followUp: '-' },
    ];

    const filteredData = prospects.filter(p => {
        const matchTab = tab === 0 ? true : tab === 1 ? p.status === 'Confirmed' || p.status === 'Paid' : tab === 2 ? p.status === 'Quoted' || p.status === 'Pending' : p.status === 'Cancelled';
        const matchSearch = !searchTerm || p.studentName.toLowerCase().includes(searchTerm.toLowerCase()) || p.parentName.toLowerCase().includes(searchTerm.toLowerCase());
        return matchTab && matchSearch;
    });

    const totalQuoted = prospects.reduce((a, p) => a + p.quotedFee, 0);
    const totalDeposits = prospects.reduce((a, p) => a + p.paidDeposit, 0);
    const confirmedCount = prospects.filter(p => p.status === 'Confirmed' || p.status === 'Paid').length;
    const pendingCount = prospects.filter(p => p.status === 'Quoted' || p.status === 'Pending').length;

    return (
        <Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                <Typography variant="h5" fontWeight={700}>Prospect Fee Management</Typography>
                <Box sx={{ display: 'flex', gap: 1 }}>
                    <Button variant="contained" startIcon={<AddIcon />} size="small" onClick={() => setOpenDialog(true)}>New Prospect</Button>
                    <Button variant="outlined" startIcon={<DownloadIcon />} size="small">Export</Button>
                </Box>
            </Box>

            <Grid container spacing={2} sx={{ mb: 3 }}>
                <Grid item xs={6} sm={3}>
                    <Card sx={{ borderLeft: '4px solid #1a9e8f' }}>
                        <CardContent sx={{ py: 1.5 }}>
                            <Typography variant="body2" color="text.secondary">Total Prospects</Typography>
                            <Typography variant="h5" fontWeight={700}>{prospects.length}</Typography>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <Card sx={{ borderLeft: '4px solid #2196f3' }}>
                        <CardContent sx={{ py: 1.5 }}>
                            <Typography variant="body2" color="text.secondary">Total Quoted</Typography>
                            <Typography variant="h5" fontWeight={700}>₹{(totalQuoted / 1000).toFixed(0)}K</Typography>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <Card sx={{ borderLeft: '4px solid #4caf50' }}>
                        <CardContent sx={{ py: 1.5 }}>
                            <Typography variant="body2" color="text.secondary">Deposits Received</Typography>
                            <Typography variant="h5" fontWeight={700} color="success.main">₹{(totalDeposits / 1000).toFixed(0)}K</Typography>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <Card sx={{ borderLeft: '4px solid #ff9800' }}>
                        <CardContent sx={{ py: 1.5 }}>
                            <Typography variant="body2" color="text.secondary">Conversion Rate</Typography>
                            <Typography variant="h5" fontWeight={700}>{Math.round((confirmedCount / prospects.length) * 100)}%</Typography>
                            <LinearProgress variant="determinate" value={(confirmedCount / prospects.length) * 100}
                                sx={{ mt: 0.5, height: 4, borderRadius: 2 }} />
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>

            <Card>
                <Tabs value={tab} onChange={(e, v) => setTab(v)} sx={{ borderBottom: 1, borderColor: 'divider', px: 2 }}>
                    <Tab label={`All (${prospects.length})`} />
                    <Tab label={`Confirmed (${confirmedCount})`} />
                    <Tab label={`Pending (${pendingCount})`} />
                    <Tab label="Cancelled" />
                </Tabs>
                <Box sx={{ p: 2 }}>
                    <TextField fullWidth size="small" placeholder="Search by student or parent name..." value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)} sx={{ mb: 2 }}
                        InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon fontSize="small" /></InputAdornment> }} />

                    <TableContainer>
                        <Table size="small">
                            <TableHead>
                                <TableRow sx={{ bgcolor: '#f5f5f5' }}>
                                    <TableCell sx={{ fontWeight: 700 }}>Student</TableCell>
                                    <TableCell sx={{ fontWeight: 700 }}>Parent</TableCell>
                                    <TableCell sx={{ fontWeight: 700 }}>Phone</TableCell>
                                    <TableCell sx={{ fontWeight: 700 }}>Class</TableCell>
                                    <TableCell align="right" sx={{ fontWeight: 700 }}>Total Fee</TableCell>
                                    <TableCell align="right" sx={{ fontWeight: 700 }}>Discount</TableCell>
                                    <TableCell align="right" sx={{ fontWeight: 700 }}>Quoted</TableCell>
                                    <TableCell align="right" sx={{ fontWeight: 700 }}>Deposit</TableCell>
                                    <TableCell sx={{ fontWeight: 700 }}>Follow Up</TableCell>
                                    <TableCell sx={{ fontWeight: 700 }}>Status</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filteredData.map(p => (
                                    <TableRow key={p.id} hover>
                                        <TableCell sx={{ fontWeight: 600 }}>{p.studentName}</TableCell>
                                        <TableCell>{p.parentName}</TableCell>
                                        <TableCell>{p.phone}</TableCell>
                                        <TableCell>{p.class}</TableCell>
                                        <TableCell align="right">₹{p.totalFee.toLocaleString()}</TableCell>
                                        <TableCell align="right" sx={{ color: p.discount > 0 ? '#e91e63' : 'inherit' }}>{p.discount > 0 ? `-₹${p.discount.toLocaleString()}` : '-'}</TableCell>
                                        <TableCell align="right" sx={{ fontWeight: 600 }}>₹{p.quotedFee.toLocaleString()}</TableCell>
                                        <TableCell align="right" sx={{ color: '#4caf50', fontWeight: 600 }}>{p.paidDeposit > 0 ? `₹${p.paidDeposit.toLocaleString()}` : '-'}</TableCell>
                                        <TableCell>{p.followUp !== '-' ? new Date(p.followUp).toLocaleDateString() : '-'}</TableCell>
                                        <TableCell>
                                            <Chip size="small" label={p.status}
                                                color={p.status === 'Confirmed' || p.status === 'Paid' ? 'success' : p.status === 'Cancelled' ? 'error' : 'warning'} />
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </Card>

            <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="sm" fullWidth>
                <DialogTitle>Add New Prospect</DialogTitle>
                <DialogContent>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                        <TextField label="Student Name" fullWidth value={formData.studentName} onChange={(e) => setFormData({ ...formData, studentName: e.target.value })} />
                        <TextField label="Parent Name" fullWidth value={formData.parentName} onChange={(e) => setFormData({ ...formData, parentName: e.target.value })} />
                        <TextField label="Phone" fullWidth value={formData.phone} onChange={(e) => setFormData({ ...formData, phone: e.target.value })} />
                        <TextField select label="Class" fullWidth value={formData.class} onChange={(e) => setFormData({ ...formData, class: e.target.value })}>
                            {['LKG', 'UKG', 'Class 1A', 'Class 2A', 'Class 3B', 'Class 5A', 'Class 6A', 'Class 8A'].map(c => <MenuItem key={c} value={c}>{c}</MenuItem>)}
                        </TextField>
                        <Grid container spacing={2}>
                            <Grid item xs={4}><TextField label="Total Fee (₹)" fullWidth type="number" value={formData.totalFee} onChange={(e) => setFormData({ ...formData, totalFee: e.target.value })} /></Grid>
                            <Grid item xs={4}><TextField label="Discount (₹)" fullWidth type="number" value={formData.discount} onChange={(e) => setFormData({ ...formData, discount: e.target.value })} /></Grid>
                            <Grid item xs={4}><TextField label="Quoted Fee (₹)" fullWidth type="number" value={formData.quotedFee} onChange={(e) => setFormData({ ...formData, quotedFee: e.target.value })} /></Grid>
                        </Grid>
                    </Box>
                </DialogContent>
                <DialogActions sx={{ p: 2 }}>
                    <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
                    <Button variant="contained" onClick={() => { toast.success('Prospect added'); setOpenDialog(false); }}>Save</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default ProspectFees;
